import React from 'react'

function LushUnits() {
    return (
        <section id="listing">
            <div className='container my-5'>
                <div className='row' >
                    <h1 className='text-primary fw-bold text-start mb-0'>Available Units</h1>
                    <p className='text-start '>
                        <small>
                            Select your unit from our remaining availability.
                        </small>
                    </p>

                    <div className='col-lg-4 mb-2' >
                        <div className='card h-100' style={{ background: "#325d88" }}>
                            <div className='row'>
                                <a href='/Images/Lush/UnitLayout3.png'>
                                    <img src="/Images/Lush/UnitLayout3.png" className="img-fluid" alt="..."></img>
                                </a>
                                <div className='' >
                                    <p className='text-center text-white'>
                                        <sub>
                                            <i>
                                                Click/Tap Image to enlarge
                                            </i>
                                        </sub>
                                    </p>
                                </div>
                            </div>

                            <div className='row mx-0 text-white' >
                                <div className='d-flex justify-content-around pt-2'>
                                    <div className='d-flex flex-column'>
                                        <p className='mb-0 pb-0'><small>Studio</small></p>
                                        <p className='mb-0 px-2 border border-success border-1 rounded-pill'><small>1</small></p>
                                    </div>
                                    <div className='d-flex flex-column'>
                                        <p className='mb-0 pb-0'><small>Bathroom</small></p>
                                        <p className='mb-0 px-2 border border-success border-1 rounded-pill'><small>1</small></p>
                                    </div>
                                    <div className='d-flex flex-column'>
                                        <p className='mb-0 pb-0'><small>Balcony</small></p>
                                        <p className='mb-0 px-2 border border-success border-1 rounded-pill'><small>optional</small></p>
                                    </div>
                                </div>
                            </div>
                            <div className='row mx-0 text-white' style={{ background: "#325d88" }}>
                                <div className='d-flex flex-column mt-3'>
                                    <h5 className='text-start p-0 m-0'>Studio / Studio with Balcony</h5>
                                </div>
                                <div className='d-flex justify-content-start pt-2' >
                                    <div className='d-flex flex-column'>
                                        <p className='text-start mb-0 pb-0'>Studio</p>
                                        <ul className='text-start'>
                                            <li><small>Area: 21.73 sqm</small></li>
                                            <li><small>Area: 233.81 sq.ft.</small></li>
                                            <li><small>Price (PHP): 5.794M – 6.574M</small></li>
                                            <li><small>Price (USD): 112.776K – 127.958K</small></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-start' >
                                    <div className='d-flex flex-column'>
                                        <p className='text-start mb-0 pb-0'>Studio with BALCONY</p>
                                        <ul className='text-start'>
                                            <li><small>Area: 22.12 - 22.99 sqm</small></li>
                                            <li><small>Area: 238.01 - 247.37 sq.ft.</small></li>
                                            <li><small>Price (PHP): 6.763M - 7.74M</small></li>
                                            <li><small>Price (USD): 131.637K - 150.653K</small></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className='' >
                                    <p className='text-start text-white'>
                                        <sub>
                                            <i>
                                                Prices are as of April 7, 2022. Prices are as of April 7, 2022.Availability
                                                <br />
                                                and Prices (appreciation over time) are subject to change.
                                            </i>
                                        </sub>
                                    </p>
                                </div>

                                <div className='d-flex justify-content-start pb-3' >
                                    <a className='btn btn-success bg-success text-white'>Contact Us for more Details</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4 mb-2' >
                        <div className='card h-100' style={{ background: "#325d88" }}>
                            <div className='row'>
                                <a href='/Images/Lush/UnitLayout3.png'>
                                    <img src="/Images/Lush/UnitLayout3.png" className="img-fluid" alt="..."></img>
                                </a>
                                <div className='' >
                                    <p className='text-center text-white'>
                                        <sub>
                                            <i>
                                                Click/Tap Image to enlarge
                                            </i>
                                        </sub>
                                    </p>
                                </div>
                            </div>
                            <div className='row mx-0 text-white' >
                                <div className='d-flex justify-content-around pt-2'>
                                    <div className='d-flex flex-column'>
                                        <p className='mb-0 pb-0'><small>Bedroom</small></p>
                                        <p className='mb-0 px-2 border border-success border-1 rounded-pill'><small>1</small></p>
                                    </div>
                                    <div className='d-flex flex-column'>
                                        <p className='mb-0 pb-0'><small>Bathroom</small></p>
                                        <p className='mb-0 px-2 border border-success border-1 rounded-pill'><small>1</small></p>
                                    </div>
                                    <div className='d-flex flex-column'>
                                        <p className='mb-0 pb-0'><small>Balcony / Den</small></p>
                                        <p className='mb-0 px-2 border border-success border-1 rounded-pill'><small>1</small></p>
                                    </div>
                                </div>

                                <div className='d-flex flex-column mt-3'>
                                    <h5 className='text-start p-0 m-0'>Bedroom with Balcony / Den</h5>
                                </div>
                            </div>
                            <div className='row mx-0 text-white' style={{ background: "#325d88" }}>
                                <div className='d-flex justify-content-start pt-2' >
                                    <div className='d-flex flex-column'>
                                        <p className='text-start mb-0 pb-0'>Bedroom with Balcony</p>
                                        <ul className='text-start'>
                                            <li><small>Area: 30.81 sqm</small></li>
                                            <li><small>Area: 331.52 sq.ft.</small></li>
                                            <li><small>Price (PHP): 7.289M – 9.29M</small></li>
                                            <li><small>Price (USD): 141.875K – 180.823K</small></li>
                                            <li><small>3 units per floor end unit</small></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-start' >
                                    <div className='d-flex flex-column'>
                                        <p className='text-start mb-0 pb-0'>Bedroom with Den</p>
                                        <ul className='text-start'>
                                            <li><small>Area: 33.58 sqm</small></li>
                                            <li><small>Area: 361.32 sq.ft.</small></li>
                                            <li><small>Price (PHP): 8.952M – 10.181M</small></li>
                                            <li><small>Price (USD): 174.244K – 198.166K</small></li>
                                            <li><small>1 unit per floor only</small></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className='' >
                                    <p className='text-start text-white'>
                                        <sub>
                                            <i>
                                                Prices are as of April 7, 2022. Prices are as of April 7, 2022.Availability
                                                <br />
                                                and Prices (appreciation over time) are subject to change.
                                            </i>
                                        </sub>
                                    </p>
                                </div>

                                <div className='d-flex justify-content-start pb-3' >
                                    <a className='btn btn-success bg-success text-white'>Contact Us for more Details</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4 mb-2' >
                        <div className='card h-100' style={{ background: "#325d88" }}>
                            <div className='row'>
                                <a href='/Images/Lush/UnitLayout2.png'>
                                    <img src="/Images/Lush/UnitLayout2.png" className="img-fluid" alt="..."></img>
                                </a>
                                <div className='' >
                                    <p className='text-center text-white'>
                                        <sub>
                                            <i>
                                                Click/Tap Image to enlarge
                                            </i>
                                        </sub>
                                    </p>
                                </div>
                            </div>
                            <div className='row mx-0 text-white' >
                                <div className='d-flex justify-content-around pt-2'>
                                    <div className='d-flex flex-column'>
                                        <p className='mb-0 pb-0'><small>Bedroom</small></p>
                                        <p className='mb-0 px-2 border border-success border-1 rounded-pill'><small>1</small></p>
                                    </div>
                                    <div className='d-flex flex-column'>
                                        <p className='mb-0 pb-0'><small>Bathroom</small></p>
                                        <p className='mb-0 px-2 border border-success border-1 rounded-pill'><small>1</small></p>
                                    </div>
                                    <div className='d-flex flex-column'>
                                        <p className='mb-0 pb-0'><small>Balcony</small></p>
                                        <p className='mb-0 px-2 border border-success border-1 rounded-pill'><small>1</small></p>
                                    </div>
                                </div>

                                <div className='d-flex flex-column mt-3'>
                                    <h5 className='text-start p-0 m-0'>Bedroom / Bedroom with Balcony</h5>
                                </div>
                            </div>
                            <div className='row mx-0 text-white' style={{ background: "#325d88" }}>
                                <div className='d-flex justify-content-start pt-2' >
                                    <div className='d-flex flex-column'>
                                        <p className='text-start mb-0 pb-0'>Bedroom</p>
                                        <ul className='text-start'>
                                            <li><small>Area: 33.58 sqm</small></li>
                                            <li><small>Area: 361.32 sq.ft.</small></li>
                                            <li><small>Price (PHP): 5.794M – 6.574M</small></li>
                                            <li><small>Price (USD): 112.776K – 127.958K</small></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-start' >
                                    <div className='d-flex flex-column'>
                                        <p className='text-start mb-0 pb-0'>Studio with Balcony</p>
                                        <ul className='text-start'>
                                            <li><small>Area: 24.49 - 31.96 sqm</small></li>
                                            <li><small>Area: 263.51 - 343.89 sq.ft.</small></li>
                                            <li><small>Price (PHP): 7.699M - 9.689M</small></li>
                                            <li><small>Price (USD): 149.855 - 188.589K</small></li>
                                        </ul>
                                    </div>
                                </div>

                                <div className='' >
                                    <p className='text-start text-white'>
                                        <sub>
                                            <i>
                                                Prices are as of April 7, 2022. Prices are as of April 7, 2022.Availability
                                                <br />
                                                and Prices (appreciation over time) are subject to change.
                                            </i>
                                        </sub>
                                    </p>
                                </div>

                                <div className='d-flex justify-content-start pb-3' >
                                    <a className='btn btn-success bg-success text-white'>Contact Us for more Details</a>
                                </div>
                            </div>
                        </div>
                    </div>




                </div>
            </div>

        </section>
    )
}

export default LushUnits